var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDspCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18626_21370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5907 40.2139L30.0634 42.8703L29.4102 45.9186L34.0697 42.3912L33.5907 40.2139Z",
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3302 43.5239L30.0625 46.79L32.1963 48.8367C32.2254 48.8658 32.2544 48.8803 32.2834 48.8803C32.327 48.8803 32.3705 48.8803 32.3705 48.8367L34.8527 46.1803C34.8963 46.1368 34.8963 46.0932 34.8963 46.0061L34.3302 43.5239Z",
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3272 37.2963L30.4563 41.3026L33.3304 39.0817L32.9385 37.3398L34.1578 35.8157C34.2014 35.7721 34.2014 35.685 34.2014 35.6415L33.4175 33.6818C33.3739 33.6383 33.3304 33.5947 33.2869 33.5947H30.9788C30.9353 33.5947 30.8917 33.6383 30.8482 33.6818L30.1079 35.6415C30.0643 35.685 30.1079 35.7721 30.1514 35.8157L31.3272 37.2963Z",
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5594 23.3611C40.5594 28.0207 36.8143 31.7658 32.1547 31.7658C27.4951 31.7658 23.75 28.0643 23.75 23.4047C23.75 18.7451 27.5386 15 32.1547 15C36.7707 15 40.5594 18.7015 40.5594 23.3611Z",
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6968 42.522L45.7839 40.301C45.7839 36.5995 42.7791 33.5947 39.0776 33.5947H38.8598L35.5938 48.1832C39.5566 47.3558 43.0404 45.3526 45.6968 42.522ZM42.8662 40.214H39.7743V39.2124H42.8662V40.214Z",
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6256 48.3138L25.0112 33.5947H24.7063C21.0048 33.5947 18 36.5995 18 40.301L18.0871 42.8268C20.8741 45.6574 24.5321 47.617 28.6256 48.3138Z",
    fill: "#0F5EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18626_21370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.7833,
    height: 33.88,
    fill: "white",
    transform: "translate(18 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDspCardIcon);
export default __webpack_public_path__ + "static/media/DspCardIcon.b0a7aa478c45549341da77ee42aa48e3.svg";
export { ForwardRef as ReactComponent };